module.exports = __webpack_public_path__ + "img/beckett.4c52a5d3.jpg";